import * as React from 'react';

const styles = require('./ReimbursementFlagsChips.pcss');

type Props = {
  flags: Record<string, boolean> | null;
  reimbursement?: any;
};

const ReimbursementFlagsChips: React.FC<Props> = ({ flags, reimbursement }) => {
  if (!flags) {
    return null;
  }
  const reimbursementFrequency = reimbursement?.value?.frequency;
  const reimbursementsDisabled =
    !reimbursementFrequency ||
    reimbursementFrequency === 'disabled' ||
    reimbursementFrequency === 'paused';
  return (
    <div className={styles.flagsContainer}>
      <div
        className={
          reimbursementsDisabled ? styles.flagWarning : styles.flagSuccess
        }
      >
        {reimbursementsDisabled
          ? 'Reimbursements Paused'
          : 'Reimbursements Active'}
      </div>
      <div
        className={
          flags.virtualAccountSynced ? styles.flagSuccess : styles.flagWarning
        }
      >
        {flags.virtualAccountSynced
          ? 'Virtual Account Synced'
          : 'Virtual Account Not Synced'}
      </div>
    </div>
  );
};

export default ReimbursementFlagsChips;
